import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  inject,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Client, OnePProjectCostTotalsDTO } from '../../../api/api-clientInformation';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BreakInOutEditModel } from '../../report-form/models/break-in-out-edit-model';
import { CostTotalsService } from '../../../services/cost-totals.service';

@Component({
  selector: 'app-break-in-out-totals-dialog',
  standalone: false,
  templateUrl: './break-in-out-totals-dialog.component.html',
  styleUrl: './break-in-out-totals-dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreakInOutTotalsDialogComponent implements OnInit {
  apiClient = inject(Client);
  loading = false;
  title = 'Break In/Out Totals';
  description: string | undefined;
  totals = {} as OnePProjectCostTotalsDTO;
  private _fb: FormBuilder = new FormBuilder();
  public breakInOutForm!: FormGroup;
  private justificationFormControl = this._fb.control('');
  private materialJanFormControl = this._fb.control(0);
  private materialFebFormControl = this._fb.control(0);
  private materialMarFormControl = this._fb.control(0);
  private materialAprFormControl = this._fb.control(0);
  private materialMayFormControl = this._fb.control(0);
  private materialJunFormControl = this._fb.control(0);
  private materialJulFormControl = this._fb.control(0);
  private materialAugFormControl = this._fb.control(0);
  private materialSepFormControl = this._fb.control(0);
  private materialOctFormControl = this._fb.control(0);
  private materialNovFormControl = this._fb.control(0);
  private materialDecFormControl = this._fb.control(0);
  private serviceJanFormControl = this._fb.control(0);
  private serviceFebFormControl = this._fb.control(0);
  private serviceMarFormControl = this._fb.control(0);
  private serviceAprFormControl = this._fb.control(0);
  private serviceMayFormControl = this._fb.control(0);
  private serviceJunFormControl = this._fb.control(0);
  private serviceJulFormControl = this._fb.control(0);
  private serviceAugFormControl = this._fb.control(0);
  private serviceSepFormControl = this._fb.control(0);
  private serviceOctFormControl = this._fb.control(0);
  private serviceNovFormControl = this._fb.control(0);
  private serviceDecFormControl = this._fb.control(0);
  private otherJanFormControl = this._fb.control(0);
  private otherFebFormControl = this._fb.control(0);
  private otherMarFormControl = this._fb.control(0);
  private otherAprFormControl = this._fb.control(0);
  private otherMayFormControl = this._fb.control(0);
  private otherJunFormControl = this._fb.control(0);
  private otherJulFormControl = this._fb.control(0);
  private otherAugFormControl = this._fb.control(0);
  private otherSepFormControl = this._fb.control(0);
  private otherOctFormControl = this._fb.control(0);
  private otherNovFormControl = this._fb.control(0);
  private otherDecFormControl = this._fb.control(0);
  private totalJanFormControl = this._fb.control(0);
  private totalFebFormControl = this._fb.control(0);
  private totalMarFormControl = this._fb.control(0);
  private totalAprFormControl = this._fb.control(0);
  private totalMayFormControl = this._fb.control(0);
  private totalJunFormControl = this._fb.control(0);
  private totalJulFormControl = this._fb.control(0);
  private totalAugFormControl = this._fb.control(0);
  private totalSepFormControl = this._fb.control(0);
  private totalOctFormControl = this._fb.control(0);
  private totalNovFormControl = this._fb.control(0);
  private totalDecFormControl = this._fb.control(0);
  private totalMaterialFormControl = this._fb.control(0);
  private totalServiceFormControl = this._fb.control(0);
  private totalOtherFormControl = this._fb.control(0);
  private totalGeneralFormControl = this._fb.control(0);

  constructor(
    private fb: FormBuilder,
    private costTotalsService: CostTotalsService,
    private dialogRef: MatDialogRef<BreakInOutTotalsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this._fb = fb;
  }

  ngAfterViewInit() {
    if (this.data.model.totals) {
      const initiativeCostTotals = this.data.model.totals;
      this.breakInOutForm.patchValue(initiativeCostTotals);
      this.breakInOutForm
        .get('justification')
        ?.setValue(this.data.model.justification ?? '');
      this.calculateTotals();
    }
    if (this.data.title) {
      this.title = this.data.title;
    }
    if (this.data.description) {
      this.description = this.data.description;
    }
  }

  ngOnInit(): void {
    this.breakInOutForm = this.fb.group({
      justification: this.justificationFormControl,
      janMaterial: this.materialJanFormControl,
      febMaterial: this.materialFebFormControl,
      marMaterial: this.materialMarFormControl,
      aprMaterial: this.materialAprFormControl,
      mayMaterial: this.materialMayFormControl,
      junMaterial: this.materialJunFormControl,
      julMaterial: this.materialJulFormControl,
      augMaterial: this.materialAugFormControl,
      sepMaterial: this.materialSepFormControl,
      octMaterial: this.materialOctFormControl,
      novMaterial: this.materialNovFormControl,
      decMaterial: this.materialDecFormControl,
      janService: this.serviceJanFormControl,
      febService: this.serviceFebFormControl,
      marService: this.serviceMarFormControl,
      aprService: this.serviceAprFormControl,
      mayService: this.serviceMayFormControl,
      junService: this.serviceJunFormControl,
      julService: this.serviceJulFormControl,
      augService: this.serviceAugFormControl,
      sepService: this.serviceSepFormControl,
      octService: this.serviceOctFormControl,
      novService: this.serviceNovFormControl,
      decService: this.serviceDecFormControl,
      janOther: this.otherJanFormControl,
      febOther: this.otherFebFormControl,
      marOther: this.otherMarFormControl,
      aprOther: this.otherAprFormControl,
      mayOther: this.otherMayFormControl,
      junOther: this.otherJunFormControl,
      julOther: this.otherJulFormControl,
      augOther: this.otherAugFormControl,
      sepOther: this.otherSepFormControl,
      octOther: this.otherOctFormControl,
      novOther: this.otherNovFormControl,
      decOther: this.otherDecFormControl,
      janTotal: this.totalJanFormControl,
      febTotal: this.totalFebFormControl,
      marTotal: this.totalMarFormControl,
      aprTotal: this.totalAprFormControl,
      mayTotal: this.totalMayFormControl,
      junTotal: this.totalJunFormControl,
      julTotal: this.totalJulFormControl,
      augTotal: this.totalAugFormControl,
      sepTotal: this.totalSepFormControl,
      octTotal: this.totalOctFormControl,
      novTotal: this.totalNovFormControl,
      decTotal: this.totalDecFormControl,
      totalMaterial: this.totalMaterialFormControl,
      totalService: this.totalServiceFormControl,
      totalOther: this.totalOtherFormControl,
      total: this.totalGeneralFormControl,
    });

    // diable totals
    this.totalJanFormControl.disable();
    this.totalFebFormControl.disable();
    this.totalMarFormControl.disable();
    this.totalAprFormControl.disable();
    this.totalMayFormControl.disable();
    this.totalJunFormControl.disable();
    this.totalJulFormControl.disable();
    this.totalAugFormControl.disable();
    this.totalSepFormControl.disable();
    this.totalOctFormControl.disable();
    this.totalNovFormControl.disable();
    this.totalDecFormControl.disable();
    this.totalMaterialFormControl.disable();
    this.totalServiceFormControl.disable();
    this.totalOtherFormControl.disable();
    this.totalGeneralFormControl.disable();

    const currentDate = new Date();
    if(this.data.hasPendingBreakInOut){
      this.disablePastMonths(12);
    }
    else if (this.data.year && this.data.year < currentDate.getFullYear() + 1){
      this.disablePastMonths(currentDate.getMonth());
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.breakInOutForm.valid) {
      Object.assign(
        this.data.model.totals,
        this.breakInOutForm.getRawValue()
      );
      this.dialogRef.close({
        breakInOutId: this.data.model.breakInOutId,
        totals: this.data.model.totals,
        justification: this.justificationFormControl.value,
      } as BreakInOutEditModel);
    }
  }

  private disablePastMonths(monthIndex: number) {
    if (monthIndex >= 1) {
      this.materialJanFormControl.disable();
      this.serviceJanFormControl.disable();
      this.otherJanFormControl.disable();
    }
    if (monthIndex >= 2) {
      this.materialFebFormControl.disable();
      this.serviceFebFormControl.disable();
      this.otherFebFormControl.disable();
    }
    if (monthIndex >= 3) {
      this.materialMarFormControl.disable();
      this.serviceMarFormControl.disable();
      this.otherMarFormControl.disable();
    }
    if (monthIndex >= 4) {
      this.materialAprFormControl.disable();
      this.serviceAprFormControl.disable();
      this.otherAprFormControl.disable();
    }
    if (monthIndex >= 5) {
      this.materialMayFormControl.disable();
      this.serviceMayFormControl.disable();
      this.otherMayFormControl.disable();
    }
    if (monthIndex >= 6) {
      this.materialJunFormControl.disable();
      this.serviceJunFormControl.disable();
      this.otherJunFormControl.disable();
    }
    if (monthIndex >= 7) {
      this.materialJulFormControl.disable();
      this.serviceJulFormControl.disable();
      this.otherJulFormControl.disable();
    }
    if (monthIndex >= 8) {
      this.materialAugFormControl.disable();
      this.serviceAugFormControl.disable();
      this.otherAugFormControl.disable();
    }
    if (monthIndex >= 9) {
      this.materialSepFormControl.disable();
      this.serviceSepFormControl.disable();
      this.otherSepFormControl.disable();
    }
    if (monthIndex >= 10) {
      this.materialOctFormControl.disable();
      this.serviceOctFormControl.disable();
      this.otherOctFormControl.disable();
    }
    if (monthIndex >= 11) {
      this.materialNovFormControl.disable();
      this.serviceNovFormControl.disable();
      this.otherNovFormControl.disable();
    }
    if (monthIndex >= 12) {
      this.materialDecFormControl.disable();
      this.serviceDecFormControl.disable();
      this.otherDecFormControl.disable();
    }
  }

  calculateTotals(): void {
    let materialJan = this.materialJanFormControl.value as number;
    let materialFeb = this.materialFebFormControl.value as number;
    let materialMar = this.materialMarFormControl.value as number;
    let materialApr = this.materialAprFormControl.value as number;
    let materialMay = this.materialMayFormControl.value as number;
    let materialJun = this.materialJunFormControl.value as number;
    let materialJul = this.materialJulFormControl.value as number;
    let materialAug = this.materialAugFormControl.value as number;
    let materialSep = this.materialSepFormControl.value as number;
    let materialOct = this.materialOctFormControl.value as number;
    let materialNov = this.materialNovFormControl.value as number;
    let materialDec = this.materialDecFormControl.value as number;
    let serviceJan = this.serviceJanFormControl.value as number;
    let serviceFeb = this.serviceFebFormControl.value as number;
    let serviceMar = this.serviceMarFormControl.value as number;
    let serviceApr = this.serviceAprFormControl.value as number;
    let serviceMay = this.serviceMayFormControl.value as number;
    let serviceJun = this.serviceJunFormControl.value as number;
    let serviceJul = this.serviceJulFormControl.value as number;
    let serviceAug = this.serviceAugFormControl.value as number;
    let serviceSep = this.serviceSepFormControl.value as number;
    let serviceOct = this.serviceOctFormControl.value as number;
    let serviceNov = this.serviceNovFormControl.value as number;
    let serviceDec = this.serviceDecFormControl.value as number;
    let otherJan = this.otherJanFormControl.value as number;
    let otherFeb = this.otherFebFormControl.value as number;
    let otherMar = this.otherMarFormControl.value as number;
    let otherApr = this.otherAprFormControl.value as number;
    let otherMay = this.otherMayFormControl.value as number;
    let otherJun = this.otherJunFormControl.value as number;
    let otherJul = this.otherJulFormControl.value as number;
    let otherAug = this.otherAugFormControl.value as number;
    let otherSep = this.otherSepFormControl.value as number;
    let otherOct = this.otherOctFormControl.value as number;
    let otherNov = this.otherNovFormControl.value as number;
    let otherDec = this.otherDecFormControl.value as number;
    this.totalJanFormControl.setValue(materialJan + serviceJan + otherJan);
    this.totalFebFormControl.setValue(materialFeb + serviceFeb + otherFeb);
    this.totalMarFormControl.setValue(materialMar + serviceMar + otherMar);
    this.totalAprFormControl.setValue(materialApr + serviceApr + otherApr);
    this.totalMayFormControl.setValue(materialMay + serviceMay + otherMay);
    this.totalJunFormControl.setValue(materialJun + serviceJun + otherJun);
    this.totalJulFormControl.setValue(materialJul + serviceJul + otherJul);
    this.totalAugFormControl.setValue(materialAug + serviceAug + otherAug);
    this.totalSepFormControl.setValue(materialSep + serviceSep + otherSep);
    this.totalOctFormControl.setValue(materialOct + serviceOct + otherOct);
    this.totalNovFormControl.setValue(materialNov + serviceNov + otherNov);
    this.totalDecFormControl.setValue(materialDec + serviceDec + otherDec);
    let totalMaterial =
      materialJan +
      materialFeb +
      materialMar +
      materialApr +
      materialMay +
      materialJun +
      materialJul +
      materialAug +
      materialSep +
      materialOct +
      materialNov +
      materialDec;
    let totalService =
      serviceJan +
      serviceFeb +
      serviceMar +
      serviceApr +
      serviceMay +
      serviceJun +
      serviceJul +
      serviceAug +
      serviceSep +
      serviceOct +
      serviceNov +
      serviceDec;
    let totalOther =
      otherJan +
      otherFeb +
      otherMar +
      otherApr +
      otherMay +
      otherJun +
      otherJul +
      otherAug +
      otherSep +
      otherOct +
      otherNov +
      otherDec;
    this.totalMaterialFormControl.setValue(totalMaterial);
    this.totalServiceFormControl.setValue(totalService);
    this.totalOtherFormControl.setValue(totalOther);
    this.totalGeneralFormControl.setValue(
      totalMaterial + totalService + totalOther
    );
  }
}
